<template>
  <div class="onboarding_container">
    <ElectronInvisibleHeader v-if="isElectronApp" />
    <div
      class="onboarding_initial_form"
      :class="{ hidden: getIsBeingRedirected() }"
    >
      <LoginForm />
    </div>
  </div>
</template>

<script>
import preloadAppResources from '@/mixins/preloadAppResources';
import LoginForm from '@/components/elements/authentication/LoginForm';
import ElectronInvisibleHeader from '../../widgets/ElectronInvisibleHeader.vue';
import electronHelpersMixin from '@/mixins/electronHelpersMixin';
import { browserStorageGetItem } from '@/utilities/browser-storage.util';
import {
  loggedOutGoogleAccountKey,
  loggingInDifferentEmailKey,
  loggedOutAppleAccountKey,
} from '@/types/login';

export default {
  name: 'Login',
  components: {
    LoginForm,
    ElectronInvisibleHeader,
  },
  mixins: [preloadAppResources, electronHelpersMixin],
  mounted() {
    this.$nextTick(() => {
      this.onPageLoad();
    });
  },
  methods: {
    getIsBeingRedirected() {
      return (
        browserStorageGetItem(loggedOutGoogleAccountKey) ||
        browserStorageGetItem(loggingInDifferentEmailKey) ||
        browserStorageGetItem(loggedOutAppleAccountKey)
      );
    },
  },
};
</script>
